// Minimal static fingerprints for GitHub Pages deployments where Matters
// GraphQL and article HTML cannot be read cross-origin by the browser.
export default [
  {
    title: "Matters 守望相助隊幕後—猩猩，打掃，強大！",
    shortHash: "3tmz0u0a42qx",
    mediaHash: "bafybeidpjetge3s7bo3g2pmgggolg5ur63qohjb37uscy5nkhhucmbvofm",
    dataHash: "bafybeidpjetge3s7bo3g2pmgggolg5ur63qohjb37uscy5nkhhucmbvofm",
    sourceUrl: "https://matters.town/a/3tmz0u0a42qx"
  }
];
